import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import {} from 'react';
import { Flex, Text } from '../primitives/index.js';
import { LoadingSpinner } from '../common/LoadingSpinner.js';
const FetchingQuoteLoader = ({ isLoading, containerCss }) => {
    if (!isLoading) {
        return null;
    }
    return (_jsxs(Flex, { align: "center", css: {
            gap: 14,
            mb: '3',
            mt: '1',
            p: '3 0',
            m: '0 auto',
            ...containerCss
        }, children: [_jsx(LoadingSpinner, { css: { height: 16, width: 16 } }), _jsx(Text, { style: "subtitle2", children: "Fetching the best price" })] }));
};
export default FetchingQuoteLoader;
//# sourceMappingURL=FetchingQuoteLoader.js.map